"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolPanelModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const Types_1 = require("../PredefinedConfig/Common/Types");
const ToolPanelRedux_1 = require("../Redux/ActionsReducers/ToolPanelRedux");
class ToolPanelModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.ToolPanelModuleId, ModuleConstants.ToolPanelFriendlyName, 'clipboard', 'ToolPanelPopup', 'An alternative to using the Dashboard is the AdapTable Tool Panel, the Tool Panel is the collapsible area to the right of the Grid.', api);
    }
    isModuleAvailable() {
        if (!super.isModuleAvailable()) {
            return false;
        }
        return this.api.internalApi.getAdaptableInstance().hasAdaptableToolPanel;
    }
    updateOldConfig() {
        const deprecatedToolPanelConfigs = this.api.toolPanelApi.getToolPanelState().VisibleToolPanels;
        if (deprecatedToolPanelConfigs === null || deprecatedToolPanelConfigs === void 0 ? void 0 : deprecatedToolPanelConfigs.length) {
            this.api.logWarn(`Updating Obsolete VisibleToolPanels Config for ToolPanelState: [${deprecatedToolPanelConfigs}]`);
            const migratedToolPanelConfigs = deprecatedToolPanelConfigs.map((toolPanel) => ({
                Name: toolPanel,
                State: 'collapsed',
            }));
            this.api.internalApi.dispatchReduxAction((0, ToolPanelRedux_1.ToolPanelSetToolPanels)(migratedToolPanelConfigs));
        }
        else if (!this.api.toolPanelApi.getToolPanelState().ToolPanels) {
            // no predefined config provided, we will display all the panels collapsed (custom & module)
            this.api.logInfo(`No predefined ToolPanels provided, displaying all available ones (custom&system)`);
            const defaultConfig = [];
            this.api.toolPanelApi
                .getCustomToolPanels()
                .forEach((customToolPanel) => defaultConfig.push({ Name: customToolPanel.name }));
            Types_1.ALL_TOOL_PANELS.forEach((moduleToolPanel) => defaultConfig.push({ Name: moduleToolPanel }));
            this.api.internalApi.dispatchReduxAction((0, ToolPanelRedux_1.ToolPanelSetToolPanels)(defaultConfig));
        }
    }
}
exports.ToolPanelModule = ToolPanelModule;
